import { collection, doc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';

/**
 * Generates a new Firestore-native document id (a 20-char base62 string) on the client,
 * offline and without a server round-trip.
 *
 * The generated id is random and independent of the collection it is minted from, so any
 * valid collection path works; pass the entity's real collection path so the call is
 * self-documenting and the underlying reference stays valid.
 *
 * Prefer this over ad-hoc generators (`crypto.randomUUID`, `Date.now`-based strings) so that
 * every entity created on the client and persisted through a Cloud Function shares a single,
 * consistent, Firestore-native id format.
 *
 * @param path - The collection path (first segment).
 * @param segments - Optional additional path segments for nested subcollections.
 *
 * @example
 * // Top-level collection
 * const id = generateFirestoreId(FSCollections.TRIGGERS);
 *
 * @example
 * // Nested subcollection
 * const id = generateFirestoreId(
 *   FSCollections.ORGANIZATIONS, orgId, FSCollections.EVENT_TYPES,
 * );
 */
export const generateFirestoreId = (path: string, ...segments: string[]): string =>
  doc(collection(db, path, ...segments)).id;
